module.exports = __webpack_public_path__ + "static/media/spotify.0c658d9a.svg";